// extracted by mini-css-extract-plugin
export default {"banner":"Showcase_banner__77Ezt","image":"Showcase_image__wf98Z","backBtn":"Showcase_backBtn__reWj2","nextBtn":"Showcase_nextBtn__mHHmK","App":"Showcase_App__0A2Sq"};